import { render, staticRenderFns } from "./child-ring-title-bar.vue?vue&type=template&id=43d95ae9"
import script from "./child-ring-title-bar.vue?vue&type=script&lang=js"
export * from "./child-ring-title-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports